import './Company.css'
import { Flex } from "antd";
import { FC } from "react";
import { TransparentButton } from '../../common-components/CustomButtons';

export const Company: FC = () => {
  return (
    <Flex
      vertical
      gap={'large'}
      align={'center'}
      justify={'space-around'}
      className="Company-container"
    >
      <Flex vertical align={'center'} justify={'center'} style={{height: '20vh'}}>
        <h1 className="Company-header">Cégeknek</h1>
      </Flex>
      <Flex vertical justify={'center'} style={{height: '60vh'}}>
      <div className="Company-body">
      Csapatépítőkkel, egyedi megrendelésekkel is kereshettek, és egyeztetjük a részleteket.
      </div>
      </Flex>
      <Flex justify={'start'} style={{height: '20vh'}}>
              <TransparentButton
              href='#book'
              >
                {"EGYEDI AJÁNLAT"}
              </TransparentButton>
      </Flex>
    </Flex>
  )
}
